<div id="new-recording">
    <div class="btn-list">
        <button mat-button color="primary" (click)="importRecordings()">Importar</button>
        <button mat-button color="primary" (click)="linkRecordings()">Ligar</button>
        <button mat-button color="primary" (click)="refresh()">Consultar</button>
    </div>
    <div class="rec-wrapper">
        <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate" *ngIf="isLoading">
        </mat-progress-spinner>
        <div class="p-10" *ngIf="recordingsList.length === 0 && !isLoading">
            <p>No se encontraron registros</p>
        </div>
        <table mat-table [dataSource]="recordingsList" class="mat-elevation-z8" *ngIf="!isLoading">
            <caption></caption>

            <ng-container matColumnDef="link">
                <th scope="link" mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let recording">
                    <button [disabled]="recordingsService.isMatching" mat-button
                        (click)="toggleLinking(recording, true)"><span class="fa fa-link"></span></button>
                    <button *ngIf="recording.isMatching" mat-button (click)="toggleLinking(recording, false)"
                        class="rec-close">
                        <mat-icon>close</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="fecha">
                <th scope="fecha" mat-header-cell *matHeaderCellDef> Fecha </th>
                <td mat-cell *matCellDef="let recording"> {{recording.fecha | date:"dd/MM/yyyy HH:mm" }} </td>
            </ng-container>

            <ng-container matColumnDef="telefono">
                <th scope="telefono" mat-header-cell *matHeaderCellDef> Teléfono </th>
                <td mat-cell *matCellDef="let recording"> {{recording.telefono}} </td>
            </ng-container>

            <ng-container matColumnDef="duracion">
                <th scope="duracion" mat-header-cell *matHeaderCellDef> Duración </th>
                <td mat-cell *matCellDef="let recording"> {{recording.duration}} </td>
            </ng-container>

            <ng-container matColumnDef="actuacion">
                <th scope="actuacion" mat-header-cell *matHeaderCellDef> Actuación </th>
                <td mat-cell *matCellDef="let recording"> {{recording.actuacionId}} </td>
            </ng-container>

            <ng-container matColumnDef="buttons">
                <th scope="buttons" mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let recording">
                    <button [disabled]="recording.isPlaying" mat-button
                        (click)="syncAudio(recording.grabacionId, audioStatus.Play)"><span
                            class="fa fa-play"></span></button>
                    <button [disabled]="!recording.isPlaying" mat-button
                        (click)="syncAudio(recording.grabacionId, audioStatus.Stop)"><span
                            class="fa fa-stop"></span></button>
                    <button mat-button (click)="deleteRecording(recording.grabacionId)">
                        <mat-icon>delete_forever</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
            <tr [ngClass]="{'row-linking': recording.isMatching}" mat-row
                *matRowDef="let recording; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>